<script lang="ts">
	import captureClick from '$lib/actions/captureClick';
	import { geolocation } from '$lib/state/geolocation.svelte';
	import type { GeolocationData } from '$lib/utils/geolocation';
	import { getContext, type Snippet } from 'svelte';
	import type { ClassValue, HTMLAttributes } from 'svelte/elements';

	type BtnHref = string | undefined;

	interface Props extends HTMLAttributes<HTMLAnchorElement | HTMLButtonElement> {
		showDisabledState?: boolean;
		btn?: HTMLAnchorElement | HTMLButtonElement | undefined;
		fillClass?: string;
		contentClass?: string;
		href?: BtnHref;
		type?: BtnHref extends string ? never : HTMLButtonElement['type'];
		class?: ClassValue;
		children?: Snippet;
		disabled?: boolean;
	}

	let {
		showDisabledState = true,
		btn = $bindable(),
		fillClass = '',
		contentClass = '',
		href,
		type,
		class: className,
		children,
		disabled = false,
		...other
	}: Props = $props();

	let element = $derived(href ? 'a' : 'button') as 'a' | 'button';
	let isBtn = $derived(element === 'button');

	let interactionClasses = $derived(
		isBtn
			? 'lg:group-enabled/btn:group-hover/btn:translate-y-0'
			: 'lg:group-hover/btn:translate-y-0'
	);
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<svelte:element
	this={element}
	use:captureClick
	bind:this={btn}
	{...other}
	{disabled}
	type={isBtn && !type ? 'button' : type}
	{href}
	class={[
		'group/btn relative overflow-hidden focus:outline-none',
		...(Array.isArray(className) ? className : [className]),
		{ block: !isBtn, 'disabled:opacity-25': showDisabledState }
	]}
>
	<span
		class={[
			'pointer-events-none absolute -inset-x-2 inset-y-0 block translate-y-full transform-gpu transition-transform duration-[350ms] ease-[cubic-bezier(0.24,0.8,0.4,1)] max-lg:hidden',
			interactionClasses,
			fillClass
		]}
	></span>
	<span class={['relative z-10 select-none', contentClass]}>{@render children?.()}</span>
</svelte:element>
